// src/components/Dashboard.js
import React from 'react';

const STATUS_CONFIG = {
  orcamento_enviado: { label: 'Orçamento Enviado', color: 'yellow' },
  aguardando_atendimento: { label: 'Aguardando Atendimento', color: 'green' },
  em_andamento: { label: 'Em Andamento', color: 'blue' },
  finalizada: { label: 'Finalizada', color: 'purple' },
  faturar: { label: 'Faturar', color: 'orange' },
  faturado: { label: 'Faturado', color: 'indigo' }
};

function Dashboard({ resumo, resumoFinanceiro }) {
  const formatarValor = (valor) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(valor || 0);
  };

  // Calcular lucro total (produtos + serviços)
  const calcularLucroTotal = () => {
    if (!resumoFinanceiro) return 0;
    const lucroProdutos = parseFloat(resumoFinanceiro.lucro_produtos) || 0;
    const lucroServicos = parseFloat(resumoFinanceiro.valor_servicos) || 0; // Serviços = lucro 100%
    return lucroProdutos + lucroServicos;
  };

  return (
    <div className="dashboard">
      <div className="dashboard-grid">
        {/* Cards de Status */}
        {Object.entries(STATUS_CONFIG).map(([status, config]) => {
          const item = resumo.find(r => r.status === status) || { total: 0, valor_total: 0 };
          
          return (
            <div key={status} className={`dashboard-card border-${config.color}`}>
              <div className="dashboard-card-label">{config.label}</div>
              <div className="dashboard-card-value">{item.total}</div>
              <div className="dashboard-card-amount">{formatarValor(item.valor_total)}</div>
            </div>
          );
        })}

        {/* Cards Financeiros (só aparecem se tiver dados de faturado) */}
        {resumoFinanceiro && resumoFinanceiro.total_faturado > 0 && (
          <>
            <div className="dashboard-card dashboard-card-financeiro border-blue">
              <div className="dashboard-card-label">🔧 Serviços Faturados</div>
              <div className="dashboard-card-amount">{formatarValor(resumoFinanceiro.valor_servicos)}</div>
            </div>

            <div className="dashboard-card dashboard-card-financeiro border-purple">
              <div className="dashboard-card-label">📦 Produtos Faturados</div>
              <div className="dashboard-card-amount">{formatarValor(resumoFinanceiro.valor_produtos)}</div>
            </div>

            <div className="dashboard-card dashboard-card-financeiro border-teal">
              <div className="dashboard-card-label">💎 Lucro em Produtos</div>
              <div className="dashboard-card-amount">{formatarValor(resumoFinanceiro.lucro_produtos)}</div>
            </div>

            <div className="dashboard-card dashboard-card-financeiro dashboard-card-destaque border-green">
              <div className="dashboard-card-label">💰 LUCRO TOTAL</div>
              <div className="dashboard-card-amount dashboard-card-amount-destaque">
                {formatarValor(calcularLucroTotal())}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Dashboard;
